<template>
  <div class="user">
    <side_bar :links="links"></side_bar>
    <div class="info">
      <info :infos="baseInfo" :title="'基本信息'"></info>
      <div class="split"></div>
      <info :infos="realInfo" :title="'更多信息'"></info>
    </div>
    <div class="button">
      <my_button :value="'修改密码'" :inputStyle="buttonStyle" @click.native="password"></my_button>
      <!-- <my_button :value="certify" :inputStyle="buttonStyle" @click.native="certification"></my_button> -->
      <my_button :value="'修改资料'" :inputStyle="buttonStyle" @click.native="modifyInfo"></my_button>
      <my_button :value="'退出登录'" :inputStyle="buttonStyle" @click.native="logout"></my_button>
    </div>
    <div>大赛组委会将对参赛选手个人信息严格保密</div>
    <div>若报名基本信息有误，请于{{endDate}}前联系微信客服修改</div>
  </div>
</template>

<script>
 // @ is an alias to /src
 import Info from '@/components/Info.vue'
 import MyButton from '@/components/Button.vue'
 import SideBar from '@/components/SideBar.vue';

 export default {
   name: 'User',
   computed :{
     links () {
       return this.$store.state.sbar.linksFP
     },
     user (){
       return this.$store.state.auth.user
     },
     certify() {
       return this.user.realname ? '重新认证' : "实名认证"
     },
     group() {
       let gp = [0, '小高组', '中学组', '开放组', '', '小初组']
       return gp[this.user.group]
     },
     endDate() {
       if(new Date().getMonth < 7) {
         return '5月30日'
       } else {
         return '11月30日'
       }
     },
     buttonStyle(){
       return {
         width: '6em',
         height: '2vw',
         'font-size': '0.85vw',
         'border-radius': '0.5em',
       }
     },
     baseInfo(){
       return {
         '昵称': this.user.name,
         '参赛地区': this.user.area,
         '参赛组别': this.group
       }
     },
     realInfo(){
       return{
         '真实姓名': this.user.realname,
         /* '身份证号': this.user.idcard, */
         '手机号': this.user.phone,
         '参赛单位': this.user.organization? this.user.organization:  '无' 
       }
     }
   },
   methods: {
     password() {
       this.$router.push({name: 'account', params:{type: "password"}})
     },
     certification () {
       this.$router.push({name: 'account', params: {type: 'certify'}})
     },
     modifyInfo() {
       this.$router.push({name: 'account', params: {type: 'modify'}})
     },
     logout() {
       this.$http.post('/api/login/logout')
         .then(res => {
           this.$store.commit("LOGOUT");
           this.$router.replace({name: 'account', params:{type: "login"}})
         })
     }
   },
   mounted() {

   },
   components: {

     side_bar: SideBar,
     info: Info,
     my_button: MyButton
   }
 }
</script>

<style scoped>
 .split{
   width: 2px;
   margin-top: 5%;
   height: 60%;
   background-color: rgba(0,0,0, 0.6);
 }
 .info{
   width: 100vw;
   margin-top: 4vw;
   height: 46vh;
   display: flex;
   align-items: center;
   justify-content: space-around;
 }
 .user{
   display: flex;
   flex-direction: column;
   align-items:center;
   padding-bottom: 5vh;
 }
 .button{
   display: flex;
   align-items:center;
   justify-content: space-between;
   width: 60vw;
   margin-bottom: 5vh;
   margin-top: 2vh;
 }
</style>
